/* moka-cookie-banner.js
   Rewrites the copy and the accept-button label on Shopify's NATIVE privacy banner.

   Why this exists rather than an admin setting: the banner's strings are not editable
   through the Admin API (COOKIE_BANNER is not a TranslatableResourceType, and
   privacySettings needs a read_privacy_settings scope we don't hold), so the theme is
   the only place we control them from.

   Loaded in <head> WITHOUT defer, on purpose: the observer has to be installed before
   Shopify's async storefront-banner.js injects the banner. MutationObserver callbacks
   run as microtasks after the insertion and before the next paint, so the default copy
   never gets painted. Nothing here hides the banner, so if this script fails the banner
   still renders with Shopify's own wording and stays fully usable. */
(function () {
  var COPY = 'This website uses 1st & 3rd party cookies to ensure you get the best experience on our website. ';
  var LINK_TEXT = 'Learn more';
  var CTA = 'Got it';

  function apply(banner) {
    if (!banner || banner.dataset.mokaCopy === '1') return false;

    var p = banner.querySelector('.shopify-pc__banner__body p');
    var link = banner.querySelector('#shopify-pc__banner__body-policy-link');
    if (p && link) {
      // Setting textContent drops the default sentence and detaches the link, so
      // relabel the link first and re-attach it after.
      link.textContent = LINK_TEXT;
      p.textContent = COPY;
      p.appendChild(link);
    }

    var accept = banner.querySelector('#shopify-pc__banner__btn-accept');
    if (accept) accept.textContent = CTA;

    banner.dataset.mokaCopy = '1';
    return true;
  }

  if (apply(document.getElementById('shopify-pc__banner'))) return;

  var observer = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        var banner = node.id === 'shopify-pc__banner'
          ? node
          : node.querySelector && node.querySelector('#shopify-pc__banner');
        if (apply(banner)) {
          observer.disconnect();
          return;
        }
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
